import { useState } from "react";
import Enums from "../../utilities/enum";
import { SearchSelect } from "../shared/searchSelect";
import { SearchFiltersModal } from "../shared/searchFiltersModal";
import stringHelpers from "../../utilities/stringHelpers";

export const ClientsFiltersModal = ({
	showModal,
	handleClose,
	handleConfirm,
	initialCity,
	initialType,
	initialStatus,
	initialAppliedFilters,
	cityOptions = []
}) => {
	const [city, setCity] = useState(initialCity)
	const [type, setType] = useState(initialType)
	const [status, setStatus] = useState(initialStatus)
	const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

	const clearLocalFilters = () => {
		setCity(null)
		setType(null)
		setStatus(null)
		setAppliedFilters(null)
	}

	return (
		<SearchFiltersModal
			title="Filter Results"
			handleClose={ handleClose }
			handleConfirm={ () => handleConfirm({ city, type, status, appliedFilters }) }
			showModal={ showModal }
			key="clients-filters-modal"
			handleReset={ clearLocalFilters }
		>
			<div className="w-100">
				<div className="d-flex flex-column mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">City</label>
					<SearchSelect
						defaultLabel="All"
						width="100%"
						options={ [{ value: "", label: "All" }, ...cityOptions.filter(item => !stringHelpers.isNullOrEmpty(item)).map(item => ({ value: item, label: item }))] }
						onSelect={ value => {
							if (!stringHelpers.isNullOrEmpty(value)) {
								setCity(value)
								setAppliedFilters(prevState => ({ ...prevState, "City": value }))
							} else {
								setCity(null)
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									delete updatedFilters["City"]
									return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
								})
							}
						} }
						selected={ !stringHelpers.isNullOrEmpty(city) ? city : null }
					/>
				</div>

				<div className="d-flex flex-column mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Type</label>
					<select
						value={ type === null ? "" : type }
						onChange={ e => {
							const value = stringHelpers.isNullOrEmpty(e.target.value) ? null : Number(e.target.value)
							setType(value)
							setAppliedFilters(prevState => {
								const updatedFilters = { ...prevState }
								if (value === null) {
									delete updatedFilters["Type"]
								} else {
									updatedFilters["Type"] = Enums.ClientTypes[value]
								}
								return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
							})
						} }
						className="border rounded px-2 py-1 w-100"
					>
						<option value="">All</option>
						<option value={ 0 }>Managing Agent</option>
						<option value={ 1 }>Landowner</option>
					</select>
				</div>

				<div className="d-flex flex-column mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Status</label>
					<select
						value={ status === true ? "true" : status === false ? "false" : "" }
						onChange={ e => {
							const value = e.target.value === "true" ? true : e.target.value === "false" ? false : null
							setStatus(value)
							setAppliedFilters(prevState => {
								const updatedFilters = { ...prevState }
								if (value === null) {
									delete updatedFilters["Status"]
								} else {
									updatedFilters["Status"] = value ? "Active" : "Deactivated"
								}
								return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
							})
						} }
						className="border rounded px-2 py-1 w-100"
					>
						<option value="">All</option>
						<option value="true">Active</option>
						<option value="false">Deactivated</option>
					</select>
				</div>
			</div>
		</SearchFiltersModal>
	)
}
